module.exports = __webpack_public_path__ + "img/banner3.3c2fea24.jpg";